export default __webpack_public_path__ + "static/tutorial_video-b5bf84ca1a335d4f03f81cc2f135f5f0.png";